import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X, ChevronDown } from 'lucide-react';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const toggleDropdown = (name: string) => {
    if (openDropdown === name) setOpenDropdown(null);else setOpenDropdown(name);
  };
  return <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md z-50 border-b border-slate-100 shadow-sm" data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <div className="flex justify-between items-center h-28 md:h-32" data-id="element-123">
          {/* Logo */}
          <Link to="/" className="flex items-center -my-2" aria-label="KRT Insurance Services & Consulting home" data-id="element-124">
            <img src="https://cdn.magicpatterns.com/uploads/wwyjC13qZNif2t6LP8y7yJ/KRT-insurance-CA_logo.png" alt="KRT Insurance Services & Consulting" className="h-20 md:h-24 w-auto object-contain" data-id="element-125" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-126">
            {/* Services Dropdown */}
            <div className="relative group" data-id="element-127">
              <button className="flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-navy transition-colors py-2" onMouseEnter={() => setOpenDropdown('services')} onMouseLeave={() => setOpenDropdown(null)} data-id="element-128">
                Services <ChevronDown className="w-4 h-4" data-id="element-129" />
              </button>
              {openDropdown === 'services' && <div className="absolute top-full left-0 w-64 bg-white border border-slate-100 shadow-lg rounded-xl py-2" onMouseEnter={() => setOpenDropdown('services')} onMouseLeave={() => setOpenDropdown(null)} data-id="element-130">
                  <Link to="/services/healthcare" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-131">
                    Healthcare Insurance
                  </Link>
                  <Link to="/services/benefits-review" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-132">
                    Insurance Benefits Review
                  </Link>
                  <Link to="/services/workers-comp" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-133">
                    Workers Comp Consulting
                  </Link>
                </div>}
            </div>

            {/* Coverage Dropdown */}
            <div className="relative group" data-id="element-134">
              <button className="flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-navy transition-colors py-2" onMouseEnter={() => setOpenDropdown('coverage')} onMouseLeave={() => setOpenDropdown(null)} data-id="element-135">
                Coverage <ChevronDown className="w-4 h-4" data-id="element-136" />
              </button>
              {openDropdown === 'coverage' && <div className="absolute top-full left-0 w-64 bg-white border border-slate-100 shadow-lg rounded-xl py-2" onMouseEnter={() => setOpenDropdown('coverage')} onMouseLeave={() => setOpenDropdown(null)} data-id="element-137">
                  <Link to="/insurance/medicare" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-138">
                    Medicare Insurance
                  </Link>
                  <Link to="/insurance/health" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-139">
                    Individual & Family Health
                  </Link>
                  <Link to="/insurance/life" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-140">
                    Life Insurance
                  </Link>
                  <Link to="/insurance/dental-vision" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-141">
                    Dental & Vision
                  </Link>
                  <Link to="/insurance/disability" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-142">
                    Disability Insurance
                  </Link>
                  <Link to="/insurance/travel" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-143">
                    Travel Medical
                  </Link>
                  <Link to="/insurance/employer-group" className="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-navy" data-id="element-144">
                    Employer Group Benefits
                  </Link>
                </div>}
            </div>

            <Link to="/#about" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-145">
              About Us
            </Link>
            <Link to="/#contact" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-146">
              Contact
            </Link>
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-6" data-id="element-147">
            <a href="tel:+17147264999" className="flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors" data-id="element-148">
              <Phone className="w-4 h-4" data-id="element-149" />
              <span data-id="element-150">(714) 726-4999</span>
            </a>
            <button className="bg-accent hover:bg-accent-hover text-navy-dark font-bold py-2.5 px-6 rounded-full transition-all transform hover:-translate-y-0.5 shadow-md" data-id="element-151">
              Get a Free Quote
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-4" data-id="element-152">
            <button className="bg-accent text-navy-dark font-bold py-2 px-4 rounded-full text-sm" data-id="element-153">
              Quote
            </button>
            <button className="text-navy" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-154">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-155" /> : <Menu className="w-6 h-6" data-id="element-156" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-slate-100 px-4 pt-2 pb-6 shadow-lg h-[calc(100vh-7rem)] overflow-y-auto" data-id="element-157">
          <div className="flex flex-col space-y-4 mt-4" data-id="element-158">
            {/* Mobile Services */}
            <div data-id="element-159">
              <button onClick={() => toggleDropdown('mobile-services')} className="flex items-center justify-between w-full text-base font-medium text-slate-600 py-2" data-id="element-160">
                Services{' '}
                <ChevronDown className={`w-4 h-4 transform transition-transform ${openDropdown === 'mobile-services' ? 'rotate-180' : ''}`} data-id="element-161" />
              </button>
              {openDropdown === 'mobile-services' && <div className="pl-4 flex flex-col space-y-3 mt-2 border-l-2 border-slate-100" data-id="element-162">
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/services/healthcare" className="text-sm text-slate-500" data-id="element-163">
                    Healthcare Insurance
                  </Link>
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/services/benefits-review" className="text-sm text-slate-500" data-id="element-164">
                    Insurance Benefits Review
                  </Link>
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/services/workers-comp" className="text-sm text-slate-500" data-id="element-165">
                    Workers Comp Consulting
                  </Link>
                </div>}
            </div>

            {/* Mobile Coverage */}
            <div data-id="element-166">
              <button onClick={() => toggleDropdown('mobile-coverage')} className="flex items-center justify-between w-full text-base font-medium text-slate-600 py-2" data-id="element-167">
                Coverage{' '}
                <ChevronDown className={`w-4 h-4 transform transition-transform ${openDropdown === 'mobile-coverage' ? 'rotate-180' : ''}`} data-id="element-168" />
              </button>
              {openDropdown === 'mobile-coverage' && <div className="pl-4 flex flex-col space-y-3 mt-2 border-l-2 border-slate-100" data-id="element-169">
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/insurance/medicare" className="text-sm text-slate-500" data-id="element-170">
                    Medicare Insurance
                  </Link>
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/insurance/health" className="text-sm text-slate-500" data-id="element-171">
                    Individual & Family Health
                  </Link>
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/insurance/life" className="text-sm text-slate-500" data-id="element-172">
                    Life Insurance
                  </Link>
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/insurance/dental-vision" className="text-sm text-slate-500" data-id="element-173">
                    Dental & Vision
                  </Link>
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/insurance/disability" className="text-sm text-slate-500" data-id="element-174">
                    Disability Insurance
                  </Link>
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/insurance/travel" className="text-sm text-slate-500" data-id="element-175">
                    Travel Medical
                  </Link>
                  <Link onClick={() => setIsMobileMenuOpen(false)} to="/insurance/employer-group" className="text-sm text-slate-500" data-id="element-176">
                    Employer Group Benefits
                  </Link>
                </div>}
            </div>

            <Link onClick={() => setIsMobileMenuOpen(false)} to="/#about" className="text-base font-medium text-slate-600 py-2" data-id="element-177">
              About Us
            </Link>
            <Link onClick={() => setIsMobileMenuOpen(false)} to="/#contact" className="text-base font-medium text-slate-600 py-2" data-id="element-178">
              Contact
            </Link>

            <div className="pt-4 border-t border-slate-100" data-id="element-179">
              <a href="tel:+17147264999" className="flex items-center gap-2 text-navy font-semibold mb-4" data-id="element-180">
                <Phone className="w-5 h-5" data-id="element-181" />
                <span data-id="element-182">(714) 726-4999</span>
              </a>
              <button className="w-full bg-accent hover:bg-accent-hover text-navy-dark font-bold py-3 px-6 rounded-xl transition-colors" data-id="element-183">
                Get a Free Quote
              </button>
            </div>
          </div>
        </div>}
    </header>;
}